import axios from '../utils/axios'

async function getWorkers(env = 'dev', justOnline = false) {
  try {
    const axiosInstance = axios.getInstance('prod', {}, true)
    let queryParam = `?justOnline=${justOnline}`
    console.log('queryParam', queryParam)
    let response = await axiosInstance.get(`/workers${queryParam}`)
    return (!response) ? {workers:[]} : response.data
  } catch (error) {
    console.error(error)
  }
}

export {getWorkers};


// WEBPACK FOOTER //
// ./src/requests/workers.js